import React from 'react';
import { fetchOrganisationRequest, fetchOrganisationSuccess, fetchOrganisationFailer, fetchSlaRequest, fetchSlaSuccess, fetchSlaFailer } from './SLAAction';
import DataService from '../../../../../../Service';

export const fetchSLA = (organisationId: any) => {
    return (dispatch: any) => {
        dispatch(fetchSlaRequest());
        const param: any = {};
        if (organisationId)
            param.organisation_id = organisationId;
        DataService.getData(param, 'report_fetch_sla').then((res) => {
            if (Boolean(res?.success)) {
                dispatch(fetchSlaSuccess(res?.sla_list));
            }
        }).catch((error) => {
            dispatch(fetchSlaFailer(error));
        })
    }
}

export const fetchOrganisation = () => {
    return (dispatch: any) => {
        dispatch(fetchOrganisationRequest());
        DataService.getData({}, 'organisations').then((res) => {
            if (Boolean(res?.success)) {
                dispatch(fetchOrganisationSuccess(res?.organisations));
            }
        }).catch((error) => {
            dispatch(fetchOrganisationFailer(error));
        })
    }
}